import services from "@/http";
import * as types from "./mutation-types";
import { LocalStorage } from "@/helpers/functions/localStorage";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let response = await dispatch("ActionFind", payload);
  dispatch("ActionSetMunicipios", response.data);
  dispatch("ActionSetPagination", response.meta);
};

export const ActionShow = async ({ dispatch }, payload) => {
  let municipio = await dispatch("ActionFindById", payload);
  dispatch("ActionSetMunicipio", municipio);
};

export const ActionStore = async ({ commit }, payload) => {
  await services.municipios.store(payload).then((res) => {
    commit(types.SET_MUNICIPIO, res.data.municipio);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.municipios.update(payload).then((res) => {
    commit(types.SET_MUNICIPIO, res.data.municipio);
  });
};

export const ActionDelete = async ({ commit }, id) => {
  /*
  await services.municipios.delete({ id: id }).then(() => {
    commit(types.SET_MUNICIPIO, null);
  });
  */
};

export const ActionSetMunicipios = ({ commit }, payload) => {
  commit(types.SET_MUNICIPIOS, payload);
};

export const ActionSetMunicipio = ({ commit }, payload) => {
  commit(types.SET_MUNICIPIO, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionFind = async (store, payload) => {
  let response = { data: [], meta: {} };
  await services.municipios.get_all(payload).then((res) => {
    response = res.data;
  });
  return response;
};

export const ActionFindById = async ({ dispatch }, id) => {
  let response = null;
  await services.municipios.show({ id: id }).then((res) => {
    response = res.data.cidade;
  });
  return response;
};

export const ActionNewMunicipio = ({ commit }) => {
  let payload = {
    id: "",
    name: "",
    state_initials: "",
    capital: "",
  };
  commit(types.SET_MUNICIPIO, payload);
};

/**
 * @description Actions para Estados
 */

export const ActionGetAllMunicipios = async ({ dispatch }, payload = {}) => {
  const cached = LocalStorage("@all_municipios");
  var municipios = cached.getItem;
  if (!municipios || !municipios.length) {
    const { data } = await dispatch("ActionFind", { per_page: 10000 });
    municipios = data;
    cached.store(municipios);
  }
  return municipios;
};

export const ActionGetAllEstados = async ({ commit }, payload = {}) => {
  const cachedStates = LocalStorage("@all_states");
  let estados = [];

  if (cachedStates.has) {
    estados = cachedStates.getItem;
    commit(types.SET_ESTADOS, estados);
    return estados;
  }

  try {
    payload.per_page = 50;
    const { data } = await services.municipios.get_all_estados(payload);
    estados = data.data;
    commit(types.SET_ESTADOS, estados);
    return estados;
  } catch (err) {
    cachedStates.delete();
  } finally {
    cachedStates.store(estados);
  }
};

export const ActionShowEstado = async ({ dispatch }, sigla) => {
  let estado = dispatch("ActionFindEstadoById", sigla);
  commit(types.SET_ESTADO, estado);
};

export const ActionFindEstadoById = async (store, sigla) => {
  var estado = null;
  await services.municipios.show_estados({ sigla: sigla }).then((res) => {
    estado = res.data.estado;
  });
  return estado;
};

/**
 * @description Actions para Paises
 */

export const ActionFindPais = async (store, payload = {}) => {
  let paises = [];
  payload.per_page = 50;
  await services.municipios.get_all_paises(payload).then((res) => {
    paises = res.data.data;
  });
  return paises;
};

export const ActionFindPaisByIso = async (store, iso3) => {
  var pais = null;
  await services.municipios.show_pais({ iso3: iso3 }).then((res) => {
    pais = res.data.pais;
  });
  return pais;
};
